<div *ngIf="isShownWebModal==true" id="AssotnVerifyModal" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true, backdrop: 'relative' }" (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
            <div class="modal-header d-block pt-2 pb-2 border-0 shadow-sm">
                    <p class="fnt-size18px fnt-weight500 clearfix">
                        <!-- Reattempt CME  -->
                        <span (click)="hideModal()" class="float-right cursor-pointer"><svg  class="pr-1" viewBox="0 0 20 20" width="15px"><defs ><style >.cross-post{fill:none;stroke:#3e3e3d;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}</style></defs><g  data-name="Layer 3" id="Layer_3"><line  class="cross-post" x1="2" x2="18" y1="2" y2="18"></line><line  class="cross-post" x1="18" x2="2" y1="2" y2="18"></line></g></svg></span></p>
                    
                </div>
                {{nudge_data | json}}
       <app-cme-nudge-modal *ngIf="nudge_data?.product_type==8" [nudge_data]="nudge_data"></app-cme-nudge-modal>

       <app-product-type33  *ngIf="nudge_data?.product_type==33"  [dataObj]="nudge_data?.products[0]"></app-product-type33>
 </div>
    </div>
   
  </div>
  